"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var DomUtils_1 = require("@lsg/utils/dist/esm/DomUtils");

var React = __importStar(require("react"));

var react_fast_compare_1 = __importDefault(require("react-fast-compare"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Drawer_1 = require("../../atoms/_Drawer/Drawer");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../../molecules/IconLink");

var _FilMetaBar_1 = require("./_FilMetaBar");

var _MsbMetaBar_1 = require("./_MsbMetaBar");

var _MsbMobile_1 = require("./_MsbMobile");

var _PkMetaBar_1 = require("./_PkMetaBar");

var _PkMobile_1 = require("./_PkMobile");

var Channel;

(function (Channel) {
  Channel["PK"] = "PK-WEB";
  Channel["FIL"] = "PK-INTRANET-FILIALE";
  Channel["MSB"] = "MSB_CB-WEB";
})(Channel = exports.Channel || (exports.Channel = {}));

var HeaderLegacy =
/** @class */
function (_super) {
  __extends(HeaderLegacy, _super);

  function HeaderLegacy(props) {
    var _this = _super.call(this, props) || this;

    _this.scrollLeft = function () {
      _this.updateMenuScrollPosition(_this.getMenuScrollPosition(false, _this.state.menuScrollPosition));
    };

    _this.scrollRight = function () {
      _this.updateMenuScrollPosition(_this.getMenuScrollPosition(true, _this.state.menuScrollPosition));
    };

    _this.updateViewport = function () {
      var isMobile = _this.isMobile();

      _this.setState({
        isMobile: isMobile
      });

      if (!_this.isMobile()) {
        _this.updateMenuScrollPosition(_this.state.menuScrollPosition);
      }
    };

    _this.onResize = function () {
      _this.updateMenuScrollPosition(_this.state.menuScrollPosition);
    };

    _this.isMobile = function () {
      if (!_this.props.hasMobile) {
        return false;
      }

      var viewport = utils_1.WindowEvents.getViewportSize();
      return ["xs", "sm"].includes(viewport);
    };

    _this.setOpenPath = function (openPath) {
      var isPreviousPathCorrect = openPath !== undefined && react_fast_compare_1["default"](_this.state.previousPath.slice(0, openPath.length), openPath);

      _this.setState({
        openPath: openPath,
        previousPath: isPreviousPathCorrect ? _this.state.previousPath : openPath || []
      });
    };

    _this.setTileMargins = function (navElement, key) {
      var _a; // fixed width of tiles menu


      var dropdownWidth = 303;
      var menuItemLeft = navElement.offsetLeft;
      var menuItemWidth = navElement.offsetWidth;
      var menuItemRight = menuItemLeft + menuItemWidth;
      var navLeft = navElement.parentNode.offsetLeft;
      var margin = menuItemRight - navLeft - dropdownWidth;
      _this.tilesMenuMargin = __assign(__assign({}, _this.tilesMenuMargin), (_a = {}, _a[key] = margin, _a));
    };

    _this.setStickyNavigation = function () {
      if (window.pageYOffset >= HeaderLegacy.navTop) {
        _this.mainNav.classList.add("sticky");

        if (_this.drawerNav) {
          _this.drawerNav.classList.add(CSSPrefix_1.lsgPre + "header-legacy__sticky-drawer");
        }
      } else {
        _this.mainNav.classList.remove("sticky");

        if (_this.drawerNav) {
          _this.drawerNav.classList.remove(CSSPrefix_1.lsgPre + "header-legacy__sticky-drawer");
        }
      }
    };

    _this.state = {
      isMobile: _this.isMobile(),
      previousPath: [],
      menuScrollOffset: 0,
      menuScrollPosition: 0
    };
    return _this;
  }

  HeaderLegacy.openSearchPopup = function (url, popupHeight, popupWidth, searchValue) {
    if (searchValue === void 0) {
      searchValue = "";
    }

    var searchString = url + searchValue;
    var popupParams = "dependent=no,left=0,top=0,Width=" + popupWidth + ",Height=" + popupHeight + ",scrollbars=yes,resizable=yes";
    open(searchString, "thumbnailWindow", popupParams);
  };

  HeaderLegacy.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.updateViewport);
    utils_1.WindowEvents.addResizeCallback(this.onResize);
    utils_1.WindowEvents.addScrollCallback(this.setStickyNavigation);
  };

  HeaderLegacy.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.updateViewport);
    utils_1.WindowEvents.removeResizeCallback(this.onResize);
    utils_1.WindowEvents.removeScrollCallback(this.setStickyNavigation); // remove scroll callback
  };

  HeaderLegacy.prototype.componentDidUpdate = function () {
    if (this.state.isMobile && this.mobileActiveElement && this.mobileContainer) {
      this.mobileContainer.style.height = "100%";
      this.mobileContainer.style.height = this.mobileActiveElement.scrollHeight + "px";
    }
  };

  HeaderLegacy.prototype.getMenuScrollPosition = function (isNext, menuScrollPosition) {
    if (!this.desktopMainMenu) {
      return;
    } // counting from the left


    var index = menuScrollPosition >= 0 ? menuScrollPosition : this.desktopMainMenu.childElementCount + menuScrollPosition;
    var firstElementOffsetLeft = this.desktopMainMenu.children[0].getBoundingClientRect().left;
    var elementLeft = this.desktopMainMenu.children[index].getBoundingClientRect().left - firstElementOffsetLeft;
    var elementRight = this.desktopMainMenu.children[index].getBoundingClientRect().right - firstElementOffsetLeft;
    var menuWidth = this.desktopMainMenu.getBoundingClientRect().width;
    var menuLeftEdge = menuScrollPosition >= 0 ? elementLeft : elementRight - menuWidth;
    var menuRightEdge = menuScrollPosition >= 0 ? elementLeft + menuWidth : elementRight;

    if (isNext) {
      var rightEdgeIndex = Array.from(this.desktopMainMenu.children).findIndex(function (e) {
        var eRight = e.getBoundingClientRect().right - firstElementOffsetLeft;
        return eRight > menuRightEdge + 2; // 2px tolerance
      });
      return rightEdgeIndex < 0 ? undefined : rightEdgeIndex - this.desktopMainMenu.childElementCount;
    }

    var leftEdgeReverseIndex = Array.from(this.desktopMainMenu.children).reverse().findIndex(function (e) {
      var eLeft = e.getBoundingClientRect().left - firstElementOffsetLeft;
      return eLeft < menuLeftEdge - 2; // 2px tolerance
    });
    return leftEdgeReverseIndex < 0 ? undefined : this.desktopMainMenu.childElementCount - leftEdgeReverseIndex - 1;
  };

  HeaderLegacy.prototype.updateMenuScrollPosition = function (menuScrollPosition) {
    if (!this.desktopMainMenu) {
      return;
    } // counting from the left


    var index = menuScrollPosition >= 0 ? menuScrollPosition : this.desktopMainMenu.childElementCount + menuScrollPosition;
    var firstElementOffsetLeft = this.desktopMainMenu.children[0].getBoundingClientRect().left;
    var elementLeft = this.desktopMainMenu.children[index].getBoundingClientRect().left - firstElementOffsetLeft;
    var elementRight = this.desktopMainMenu.children[index].getBoundingClientRect().right - firstElementOffsetLeft;
    var menuWidth = this.desktopMainMenu.getBoundingClientRect().width;
    var menuLeftEdge = menuScrollPosition >= 0 ? elementLeft : elementRight - menuWidth;

    if (this.desktopMainMenu.children[this.desktopMainMenu.childElementCount - 1].getBoundingClientRect().right - this.desktopMainMenu.children[0].getBoundingClientRect().left <= this.desktopMainMenu.getBoundingClientRect().width) {
      this.setState({
        menuScroll: false,
        menuScrollOffset: 0,
        menuScrollPosition: 0
      });
      return;
    }

    this.setState({
      menuScrollPosition: menuScrollPosition,
      menuScrollOffset: menuLeftEdge,
      hasNextMenuScroll: this.getMenuScrollPosition(true, menuScrollPosition) !== undefined,
      hasPreviousMenuScroll: this.getMenuScrollPosition(false, menuScrollPosition) !== undefined,
      menuScroll: true
    });
  };

  HeaderLegacy.prototype.createDesktopColumns = function (tree) {
    var _this = this;

    var subTrees = [__assign(__assign({}, tree), {
      children: []
    })];
    tree.children.forEach(function (child, i) {
      var childSubTrees = _this.createDesktopColumns(child);

      childSubTrees.forEach(function (childSubTree, j) {
        if (j > 0 || i > 0 && childSubTree.newColumn) {
          subTrees.push({
            children: []
          });
        }

        subTrees[subTrees.length - 1].children.push(childSubTree);
      });
    });
    return subTrees;
  };

  HeaderLegacy.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        openPath = _a.openPath,
        previousPath = _a.previousPath,
        isMobile = _a.isMobile,
        menuScrollOffset = _a.menuScrollOffset,
        menuScroll = _a.menuScroll,
        hasPreviousMenuScroll = _a.hasPreviousMenuScroll,
        hasNextMenuScroll = _a.hasNextMenuScroll;
    var _b = this.props,
        navigationObject = _b.navigationObject,
        mobileQuickLinks = _b.mobileQuickLinks,
        // activeValue,
    segmentTree = _b.segmentTree,
        activeSegment = _b.activeSegment,
        metaTree = _b.metaTree,
        channel = _b.channel,
        applicationData = _b.applicationData,
        resourceBundleData = _b.resourceBundleData,
        frameworkData = _b.frameworkData,
        contentIncludesData = _b.contentIncludesData;
    var tree = {
      children: navigationObject
    };
    var level2Columns = !openPath || openPath.length === 0 ? [] : this.createDesktopColumns(tree.children[openPath[0]]);
    var openMobileItems = previousPath.reduce(function (acc, val) {
      acc.push(acc[acc.length - 1].children[val]);
      return acc;
    }, [tree]);
    var openRootItem = openPath === undefined ? undefined : openMobileItems[openPath.length];
    var mobileItems = [0, 1, 2, 3, 4, 5, 6].map(function (i) {
      return openMobileItems[i] || {
        children: []
      };
    });
    var MobileMenu = channel === Channel.MSB ? _MsbMobile_1.MsbMobile : _PkMobile_1.PkMobile; // const MobileMenu = PkMobile;

    var channelSuffix = channel === Channel.PK && "pk" || channel === Channel.FIL && "fil" || channel === Channel.MSB && "msb" || "";
    return React.createElement("header", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy", CSSPrefix_1.lsgPre + "header-legacy__" + channelSuffix])
    }, !isMobile && channel === Channel.PK && React.createElement(_PkMetaBar_1.PkMetaBar, {
      applicationData: applicationData,
      frameworkData: frameworkData,
      resourceBundleData: resourceBundleData,
      contentIncludesData: contentIncludesData,
      metaTree: metaTree
    }), !isMobile && channel === Channel.MSB && React.createElement(_MsbMetaBar_1.MsbMetaBar, {
      applicationData: applicationData,
      frameworkData: frameworkData,
      resourceBundleData: resourceBundleData,
      contentIncludesData: contentIncludesData,
      metaTree: metaTree
    }), channel === Channel.FIL && React.createElement(_FilMetaBar_1.FilMetaBar, {
      applicationData: applicationData
    }), !isMobile && React.createElement("div", {
      className: "wrapper-sparten"
    }, React.createElement("div", {
      className: "wrapper-sparten-inner"
    }, React.createElement("div", {
      className: "mod mod-Logo"
    }, React.createElement("a", {
      href: contentIncludesData.logoDataUrl.url,
      title: contentIncludesData.logoDataUrl.title
    }, React.createElement("img", {
      alt: contentIncludesData.logoDataUrl.alt,
      title: contentIncludesData.logoDataUrl.title,
      src: contentIncludesData.logoDataUrl.imgLargeSVG,
      height: isMobile ? contentIncludesData.logoDataUrl.heightSmall : contentIncludesData.logoDataUrl.heightLarge,
      width: isMobile ? contentIncludesData.logoDataUrl.widthSmall : contentIncludesData.logoDataUrl.widthLarge
    }))), React.createElement("nav", {
      className: "mod mod-NavSparten"
    }, React.createElement("ul", null, segmentTree.map(function (segment) {
      return React.createElement("li", {
        className: segment.targetValue === activeSegment ? "active" : undefined
      }, React.createElement("a", {
        href: segment.href,
        onClick: segment.onClick,
        target: segment.target
      }, segment.label));
    }))))), React.createElement("nav", {
      className: CSSPrefix_1.lsgPre + "header-legacy-nav",
      ref: function ref(r) {
        _this.mainNav = r;
      }
    }, !isMobile && React.createElement(React.Fragment, null, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-legacy-menu-wrapper"
    }, menuScroll && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "header-legacy-scroll-left",
      iconName: "i_110",
      onClick: this.scrollLeft,
      disabled: !hasPreviousMenuScroll,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
    }), tree.children && !tree.children.every(function (child) {
      return child.hideMenuItem;
    }) && React.createElement("ul", {
      className: CSSPrefix_1.lsgPre + "header-legacy-menu",
      ref: function ref(r) {
        _this.desktopMainMenu = r;
      }
    }, tree.children.map(function (level1child, i) {
      if (!level1child.hideMenuItem) {
        var aProps = level1child.children.length > 0 ? {
          onClick: function onClick() {
            return _this.setOpenPath([i]);
          }
        } : {
          onClick: level1child.onClick,
          href: level1child.href,
          target: level1child.target
        };
        var isActive = openPath && openPath.length > 0 && openPath[0] === i;
        var isInactive = openPath && openPath.length > 0 && openPath[0] !== i;
        var key_1 = "" + level1child.href;
        return React.createElement("li", {
          className: CSSPrefix_1.lsgPre + "header-legacy-menu-li",
          key: key_1,
          ref: function ref(r) {
            if (level1child.isTileGroup && r) {
              _this.setTileMargins(r, key_1);
            }
          },
          style: {
            marginLeft: i === 0 ? "-" + menuScrollOffset + "px" : undefined
          }
        }, React.createElement("a", __assign({}, aProps, {
          className: DomUtils_1.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-menu-a", isActive && CSSPrefix_1.lsgPre + "header-legacy-menu-a__active", isInactive && CSSPrefix_1.lsgPre + "header-legacy-menu-a__inactive"])
        }), React.createElement("span", {
          className: CSSPrefix_1.lsgPre + "header-legacy-menu-span"
        }, level1child.label)));
      }
    })), menuScroll && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "header-legacy-scroll-right",
      iconName: "i_104",
      onClick: this.scrollRight,
      disabled: !hasNextMenuScroll,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
    }))), isMobile && React.createElement(React.Fragment, null, React.createElement("button", {
      onClick: function onClick() {
        return _this.setOpenPath([]);
      },
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-nav-show-menu", openPath !== undefined && (isMobile || openPath.length > 0) && "isActive"])
    }, React.createElement("span", null, "Menu")), React.createElement("div", {
      className: "mod mod-Logo"
    }, React.createElement("a", {
      href: contentIncludesData.logoDataUrl.url,
      title: contentIncludesData.logoDataUrl.title
    }, React.createElement("img", {
      alt: contentIncludesData.logoDataUrl.alt,
      title: contentIncludesData.logoDataUrl.title,
      src: contentIncludesData.logoDataUrl.imgLargeSVG,
      height: isMobile ? contentIncludesData.logoDataUrl.heightSmall : contentIncludesData.logoDataUrl.heightLarge,
      width: isMobile ? contentIncludesData.logoDataUrl.widthSmall : contentIncludesData.logoDataUrl.widthLarge
    }))))), React.createElement(Drawer_1.Drawer, {
      className: DomUtils_1.cleanupClassNames([window.pageYOffset >= HeaderLegacy.navTop && CSSPrefix_1.lsgPre + "header-legacy__sticky-drawer"]),
      innerRef: function innerRef(r) {
        return _this.drawerNav = r;
      },
      layout: isMobile ? Drawer_1.Drawer.Layout.LAYER_RIGHT : Drawer_1.Drawer.Layout.MEGAMENU_LEGACY,
      open: openPath !== undefined && (isMobile || openPath.length > 0),
      noFocusLock: true,
      onCloseClick: function onCloseClick() {
        _this.setOpenPath(); // TODO @cb2hayz: this was removed, but triggers an build error and prevents the menu from closing. Please check if adding it again causes any issue.

      }
    }, !isMobile && React.createElement("div", null, openPath && openPath.length > 0 && React.createElement(React.Fragment, null, React.createElement("ul", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-megamenu", tree.children[openPath[0]].isTileGroup && CSSPrefix_1.lsgPre + "header-legacy-tilesmenu"]),
      style: tree.children[openPath[0]].isTileGroup && {
        marginLeft: this.tilesMenuMargin[tree.children[openPath[0]].href] + "px"
      }
    }, level2Columns.map(function (level2Column) {
      return React.createElement("li", {
        className: CSSPrefix_1.lsgPre + "header-legacy-column"
      }, level2Column.children.map(function (level2Item) {
        return React.createElement(React.Fragment, null, level2Item.label && React.createElement("h2", {
          className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-level2", level2Item.tileSize && CSSPrefix_1.lsgPre + "header-legacy-size-" + level2Item.tileSize + "-tile", level2Item.iconName && "" + level2Item.iconName])
        }, React.createElement("a", {
          className: CSSPrefix_1.lsgPre + "header-legacy-link",
          href: level2Item.href,
          target: level2Item.target,
          onClick: level2Item.onClick
        }, level2Item.label)), level2Item.children.length > 0 && React.createElement("ul", {
          className: CSSPrefix_1.lsgPre + "header-legacy-level2-ul"
        }, level2Item.children.map(function (level3item) {
          return React.createElement("li", {
            className: CSSPrefix_1.lsgPre + "header-legacy-level3"
          }, React.createElement("a", {
            className: CSSPrefix_1.lsgPre + "header-legacy-link",
            href: level3item.href,
            target: level3item.target,
            onClick: level3item.onClick
          }, level3item.label));
        })));
      }));
    })))), isMobile && openPath !== undefined && React.createElement(MobileMenu, {
      className: CSSPrefix_1.lsgPre + "header-legacy-mobilemenu",
      onBackClick: function onBackClick() {
        return _this.setOpenPath(openPath.slice(0, -1));
      },
      isMenuRoot: openPath.length === 0,
      mobileQuickLinks: mobileQuickLinks,
      openRootItem: openRootItem,
      segmentTree: segmentTree,
      activeSegment: activeSegment,
      metaTree: metaTree,
      contentIncludesData: contentIncludesData,
      applicationData: applicationData,
      resourceBundleData: resourceBundleData,
      openPath: openPath
    }, React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-menu"])
    }, React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-menu-container"]),
      ref: function ref(r) {
        _this.mobileContainer = r;
      }
    }, mobileItems.map(function (mobileItem, level) {
      return React.createElement("ul", {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-menu-ul", level > openPath.length && CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-menu-ul-offset", CSSPrefix_1.lsgPre + "header-legacy-mobilemenu-menu-ul-level" + (level + 1)]),
        key: level + 1,
        ref: function ref(r) {
          if (level === openPath.length) {
            _this.mobileActiveElement = r;
          }
        }
      }, mobileItem.children.filter(function (item) {
        return !item.noMobile;
      }).map(function (level3item, i) {
        var aProps = level3item.children.length > 0 ? {
          onClick: function onClick() {
            return _this.setOpenPath(openPath.slice(0, level).concat([i]));
          }
        } : {
          onClick: level3item.onClick,
          href: level3item.href,
          target: level3item.target
        };
        return React.createElement("li", {
          className: CSSPrefix_1.lsgPre + "header-legacy-level3",
          key: level3item.label + "-" + i
        }, React.createElement("a", __assign({
          className: CSSPrefix_1.lsgPre + "header-legacy-link"
        }, aProps), level3item.label, level3item.children.length > 0 && React.createElement(Icon_1.Icon, {
          name: "legacy_arrow_right"
        })));
      }));
    }))))));
  };

  HeaderLegacy.navTop = 98; // header height - main nav height (142px - 44px = 98px)

  return HeaderLegacy;
}(React.Component);

exports.HeaderLegacy = HeaderLegacy;